var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_14957_2983)","key":0},[React.createElement("path",{"d":"M2.1875 7H11.8125","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.875 3.0625L11.8125 7L7.875 10.9375","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_14957_2983"},React.createElement("rect",{"width":"14","height":"14","fill":"white"})))]);
}

ArrowForward.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
